var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"container"},[_c('iframe',{attrs:{"src":"https://mp.haoxinqing.cn/mall/goods?id=21&name=%E5%9B%BE%E4%B9%A6&from=pc","frameborder":"0"}})])
}]

export { render, staticRenderFns }